module.exports = __webpack_public_path__ + "static/media/sydney-poster.6235470c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/video/sydney-poster.jpg
// module id = 534
// module chunks = 0